<template>
  <div v-if="visible" class="documents">
    <ncs-empty-result v-if="emptyResult"/>
    <template v-else>
      <ncs-page-selector/>
      <div @scroll="scrollTop" ref="scrollTop" class="scroll-top">
        <div ref="scrollTopContent"></div>
      </div>
      <div class="table-responsive" @scroll="scrollBottom" ref="scrollBottom">
        <table class="navigation-table table table-stripped table-hover table-sm">
          <thead>
          <tr>
            <th></th>
            <th>{{$t('result.context.header.document.nombre')}}</th>
            <th>{{$t('result.context.header.document.apellidos')}}</th>
            <th>{{$t('result.context.header.document.pseudonimo')}}</th>
            <th>{{$t('result.context.header.document.titulo_columna')}}</th>
            <th>{{$t('result.context.header.document.periodico')}}</th>
            <th>{{$t('result.context.header.document.lugar_publicacion')}}</th>
            <th>{{$t('result.context.header.document.fecha_publicacion')}}</th>
            <th>{{$t('result.context.header.document.pagina')}}</th>
            <th>{{$t('result.context.header.document.identificador')}}</th>
            <th>{{$t('result.context.header.document.titulo_articulo')}}</th>
            <th>{{$t('result.context.header.document.medio')}}</th>
            <th>{{$t('result.context.header.document.idioma')}}</th>
            <th>{{$t('result.context.header.document.pais')}}</th>
          </tr>
          </thead>
          <tbody ref="tableBody">
          <tr v-for="(row, index) in result.documents">
            <td>
              <a @click="showText(row, currentOffset + index + 1)" href="#">{{currentOffset + index + 1}}</a>
            </td>
            <td>{{row.nombre}}</td>
            <td>{{row.apellidos}}</td>
            <td>{{row.pseudonimo}}</td>
            <td>{{row.titulo_columna}}</td>
            <td>{{row.periodico}}</td>
            <td>{{row.lugar_publicacion}}</td>
            <td>{{row.fecha_publicacion}}</td>
            <td>{{row.pagina}}</td>
            <td>{{row.identificador}}</td>
            <td>{{row.titulo_articulo}}</td>
            <td>{{row.medio}}</td>
            <td>{{row.idioma}}</td>
            <td>{{row.pais}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <ncs-page-selector/>
    </template>
  </div>
</template>
<script>
  import {mapState} from 'vuex'

  export default {
    mounted() {
      this.initScroll()
    },
    updated() {
      this.initScroll()
    },
    computed: {
      ...mapState({
        visible: s => s.api.resultDisplay === 'documents',
        executionState: s => s.api.executionState,
        result: s => s.api.result,
        currentOffset: s => s.pagination.currentOffset
      }),
      emptyResult() {
        return this.result.documents.length === 0
      }
    },
    methods: {
      showText(row, example) {
        this.$store.dispatch('api/executeDetail', {type: 'document', query: {document: row.id, example}})
        this.$ga.page(`/search/text`)
      },
      initScroll() {
        // We have to check the execution state and result type, because we need to update scroll HTML
        // with every render, and it can happen even if the component dom is not rendered.
        // For example, when we access context api state changes and, since it's bound to this component
        // through computed properties, the updated hook will be called, but the component is not rendered.
        // Pressing back button will restore previous result and update hook will be called. This time the
        // component will be rendered and we have to initialize the top scroll again.
        if (this.visible && this.executionState === 'completed' && !this.emptyResult) {
          this.$refs.scrollTopContent.style.width = `${this.$refs.tableBody.scrollWidth}px`
        }
      },
      scrollTop() {
        this.$refs.scrollBottom.scrollLeft = this.$refs.scrollTop.scrollLeft
      },
      scrollBottom() {
        this.$refs.scrollTop.scrollLeft = this.$refs.scrollBottom.scrollLeft
      }
    }
  }
</script>
<style lang="scss" scoped>
  .scroll-top {
    overflow-x: scroll;

    & > div {
      height: 1px;
    }
  }

  .navigation-table {
    font-size: 14px;
  }
</style>